import React, { useState, memo, useRef } from 'react';
import PropTypes from 'prop-types';
import { ExpandMore, ShortText as ShortTextIcon, DateRange as DateRangeIcon } from '@mui/icons-material';
import { IconButton, ClickAwayListener } from '@mui/material';

import { onTextFilter as OnTextFilter } from '../CommonTableDataFilter/CommonTableDataFilter';
import TooltipWrapper from './TooltipWrapper';
import RenderDatepickerFilter from './RenderDatePickerFilter';
import Menu from '../Menu/Menu';
import MenuItem from '../MenuItem/MenuItem';

const iconContainerStyle = {
  position: 'absolute',
  right: 0,
  top: 0,
  display: 'flex',
};
const tooltipStyle = { display: 'inline-block' };
const iconStyle = { padding: 0, width: '28px', height: '28px' };
const containerStyle = { position: 'relative' };
const datePickerOpts = {
  style: {
    position: 'absolute',
    width: '26px',
    height: '30px',
  },
};
const inputProps = {
  style: {
    paddingRight: '55px',
    textOverflow: 'ellipsis',
  },
};

const OnTextOrDateFilter = memo(({ onChange, filter, isModal }) => {
  const [opened, setOpened] = useState(false);
  const [mode, setMode] = useState('text');
  const anchorEl = useRef(null);

  const closeDropdown = () => {
    anchorEl.current = null;
    setOpened(false);
  };
  const changeMode = (value) => {
    if (mode !== value) {
      setMode(value);
      if (filter) filter.value = '';
      if (onChange) onChange('');
    }

    closeDropdown();
  };

  const ifTextMode = () => mode === 'text';

  const onIconClick = (event) => {
    event.preventDefault();
    anchorEl.current = event.currentTarget;
    setOpened(true);
  };

  const icon = (
    <ClickAwayListener onClickAway={closeDropdown}>
      <div style={iconContainerStyle}>
        <div style={tooltipStyle}>
          <TooltipWrapper position="top" arrow tip={ifTextMode() ? <span>Text</span> : <span>Date</span>}>
            {ifTextMode() && <ShortTextIcon className="filter-gray-icon" />}
          </TooltipWrapper>
        </div>

        <IconButton size="large" style={iconStyle} onClick={onIconClick}>
          <ExpandMore />
        </IconButton>

        <Menu open={opened} anchorEl={anchorEl.current} placement="bottom-end" modal={isModal}>
          <MenuItem onClick={() => changeMode('text')} title="Text">
            <ShortTextIcon /> Text
          </MenuItem>
          <MenuItem onClick={() => changeMode('date')} title="Date">
            <DateRangeIcon /> Date
          </MenuItem>
        </Menu>
      </div>
    </ClickAwayListener>
  );

  return (
    <div style={containerStyle} className="dropdown__textOrDate">
      {ifTextMode() ? (
        <OnTextFilter filter={filter} onChange={onChange} inputProps={inputProps} />
      ) : (
        <RenderDatepickerFilter timestampOutput onChange={onChange} opts={datePickerOpts} />
      )}
      {icon}
    </div>
  );
});

RenderDatepickerFilter.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  filter: PropTypes.any,
};

export default OnTextOrDateFilter;
